import { render, staticRenderFns } from "./DietaryDiagnosticSelect.vue?vue&type=template&id=16e34d8f&"
import script from "./DietaryDiagnosticSelect.vue?vue&type=script&lang=js&"
export * from "./DietaryDiagnosticSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports